import React from 'react'

import SearchField from './SearchField'

function CompanySearchField (props) {
  return (
    <SearchField
      label="Company"
      name="company"
      {...props}
    />
  )
}

export default CompanySearchField
